import { Fragment } from 'react';
import FormattedPrice from '../Utilities/FormattedPrice';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import { LEFT_GRID_SIZE, RIGHT_GRID_SIZE } from '../../constants/Sizes';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatPercentage } from 'I18n/utils/internal/light/numberFormatters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TaxesAndFees = ({
  adjustments,
  currencyCode
}) => {
  const getCheckoutFeeTranslationKey = appliesTo => {
    return appliesTo === 'CARD' ? 'payments.defaultCheckoutFees.badge_CARD' : 'payments.defaultCheckoutFees.badge_DIRECT_DEBIT';
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: adjustments.map(adjustment => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(GridItem, {
        size: LEFT_GRID_SIZE,
        marginBlockStart: "200",
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        gap: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h6",
          textAlign: "start",
          children: adjustment.adjustmentType === 'CHECKOUT_FEE' ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.defaultCheckoutFees.formattedCheckoutFee",
            options: {
              feePercentage: formatPercentage(adjustment.value, {
                precision: 2
              }),
              feeLabel: adjustment.label
            }
          }) : adjustment.label
        }), adjustment.adjustmentType === 'CHECKOUT_FEE' && (adjustment.appliesTo === 'CARD' || adjustment.appliesTo === 'DIRECT_DEBIT') && /*#__PURE__*/_jsx(Badge, {
          use: "koala",
          "data-test-id": "checkout-fee-badge",
          textWrap: "nowrap",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getCheckoutFeeTranslationKey(adjustment.appliesTo)
          })
        })]
      }), /*#__PURE__*/_jsx(GridItem, {
        marginBlockStart: "200",
        "data-test-id": "checkout-taxes-and-fees--amount",
        size: RIGHT_GRID_SIZE,
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "end",
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedPrice, {
            currencyCode: currencyCode,
            price: adjustment.amount
          })
        })
      })]
    }, `${adjustment.label}-${adjustment.adjustmentType}`))
  });
};
export default TaxesAndFees;